import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { IResult } from "../models/result";

/**
 * Mapper for the Study Inspirator Results
 */
export default class ResultMapper {
    public mapResults(results: IResult[]): IDictionary<IResult[]> {
        var dict: IDictionary<IResult[]> = {
            0: [],
            1: [],
            2: [],
            3: []
        };

        var ratings: number[] = results.map(x => x.rating);
        ratings.forEach(rating => {
            dict[rating.toString()] = results.filter(x => x.rating == rating) ?? [];
        });

        return dict;
    }
}